import React from 'react';

import Button from '../../Shared/UI/Button/components/Button';
import EditPencilIcon from '../../Shared/UI/EditPencilIcon/components/EditPencilIcon';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import UserNameUpdateForm from './UserNameUpdateForm';

import { useProfileState, useProfileActions } from './ProfileContext';

import styles from './ProfileUserName.module.scss';

const ProfileUserName = () => {
  const state = useProfileState();
  const { openUserNameUpdateModal, closeUserNameUpdateModal } = useProfileActions();

  const displayedUserName =
    state.user?.isABot ?
    state.user?.firstName :
    `${state.user?.firstName} ${state.user?.lastName} `;

  if (state.loading) {
    return (
      <section id={styles.userNameSection}>
        <div id={styles.userNameLoading} />
      </section>
    );
  }

  return (
    <>
      <section id={styles.userNameSection}>
        <div id={styles.userNameContainer}>
          <p id={styles.userName}>
            {displayedUserName}
          </p>
          {state.user?.isAuthenticatedUser && (
            <Button
              variant="ghost"
              icon={<EditPencilIcon />}
              iconOnly
              aria-label="Edit Name"
              onClick={() => {
                if (state.user?.isAuthenticatedUser) {
                  openUserNameUpdateModal();
                }
              }}
            />
          )}
        </div>
      </section>
      <StandardModal
        isOpen={state.userNameUpdateModalIsOpen}
        contentLabel={'Update User Name'}
        onRequestClose={() => {
          if (state.user?.isAuthenticatedUser) {
            closeUserNameUpdateModal();
          }
        }}
      >
        <UserNameUpdateForm />
      </StandardModal>
    </>
  );
};

export default ProfileUserName;
